import React, { useEffect, useCallback } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

type ResourceLocationState = {
  returnTo?: string;
  title?: string;
  initialStepIndex?: number;
};

export const ResourceView: React.FC = () => {
  const { fileId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state as ResourceLocationState | undefined;

  const handleBackClick = useCallback(() => {
    const returnTo = locationState?.returnTo;
    if (returnTo) {
      navigate(returnTo, { state: { initialStepIndex: 2 } });
    } else {
      navigate(-1);
    }
  }, [navigate, locationState]);

  // ESC key handler
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        handleBackClick();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [handleBackClick]);

  const pdfUrl = fileId ? `/api/bedrock/files/${fileId}` : '';
  const title = locationState?.title || 'Document';

  if (!fileId) {
    return (
      <div className="resource-view">
        <div className="main-content">
          <div className="profile-header profile-header-content-width">
            <div className="header-content">
              <div className="header-row">
                <button className="profile-header-back-button" onClick={handleBackClick} aria-label="Go back">
                  <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="24" height="24">
                    <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" fill="currentColor" />
                  </svg>
                </button>
                <h1>Document Not Found</h1>
              </div>
            </div>
          </div>
          <div className="error-state">
            <p>No document ID provided.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="resource-view">
      <div className="main-content">
        <div className="profile-header profile-header-content-width">
          <div className="header-content">
            <div className="header-row">
              <button className="profile-header-back-button" onClick={handleBackClick} aria-label="Go back">
                <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="24" height="24">
                  <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" fill="currentColor" />
                </svg>
              </button>
              <h1>{title}</h1>
            </div>
          </div>
        </div>
        <div className="resource-content">
          <iframe
            src={pdfUrl}
            className="pdf-embed-fullscreen"
            title={title}
          />
        </div>
      </div>
    </div>
  );
};
